import { useEffect, useRef, useState } from 'react';
import Stack from '../../../../shared/ui/stack/Stack';
import styles from './Title.module.scss';

const Title = ({ data }) => {

  const [animated, setAnimated] = useState(false);
  const [animationStarted, setAnimationStarted] = useState(false);
  const svgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (svgRef.current && !animationStarted) {
        const rect = svgRef.current.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (isVisible) {
          setAnimated(true);
          setAnimationStarted(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [animationStarted]);

    return (
        <Stack className={styles.titleQ}>
          <svg
            ref={svgRef}
            className={animated ? styles.svgQ : ''}
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="43"
            viewBox="0 0 19 43"
            fill="none"
          >
            <path
              d="M0.554799 4.34784V4.64426L0.785391 4.45801C2.36967 3.1784 4.8173 2.13357 8.38405 2.13357C12.6858 2.13357 15.2481 5.70426 15.2481 9.74159C15.2481 11.6816 14.4696 13.1635 13.2908 14.4225C12.1074 15.6863 10.5264 16.7195 8.9268 17.76L8.88112 17.7897C7.30318 18.8161 5.71056 19.852 4.51107 21.1175C3.29532 22.4001 2.47671 23.9252 2.47671 25.9228C2.47671 27.3778 2.95099 28.9643 4.08772 30.1885C5.22697 31.4154 7.01845 32.2642 9.62399 32.2642C10.9124 32.2642 11.92 32.0284 12.6073 31.7914C12.9508 31.673 13.2143 31.5542 13.3929 31.4644C13.4822 31.4195 13.5502 31.3819 13.5965 31.3551C13.6196 31.3417 13.6373 31.3311 13.6494 31.3236L13.6635 31.3149L13.6674 31.3124L13.6685 31.3116L13.6689 31.3114L13.6691 31.3113C13.6691 31.3112 13.6692 31.3112 13.5918 31.1926L13.6692 31.3112L13.7334 31.2693V31.1926V30.2006V29.9084L13.5043 30.0893L13.5042 30.0893L13.5042 30.0894L13.5042 30.0894L13.5041 30.0895L13.5026 30.0906L13.4942 30.0969C13.4863 30.1026 13.4737 30.1116 13.4564 30.1233C13.4218 30.1468 13.3683 30.1812 13.295 30.2229C13.1486 30.3063 12.9232 30.4192 12.6132 30.5326C11.9934 30.7594 11.0335 30.989 9.68599 30.989C8.10823 30.989 7.03333 30.4594 6.35122 29.6883C5.66627 28.914 5.36381 27.8808 5.36381 26.8528C5.36381 25.3775 6.14666 24.2471 7.35783 23.2186C8.28222 22.4337 9.43931 21.7215 10.6637 20.968C11.0504 20.73 11.4437 20.4879 11.8386 20.238C15.1126 18.1665 18.4452 15.5878 18.4452 10.5476C18.4452 7.79242 17.6309 5.36731 15.9726 3.63009C14.3132 1.89163 11.8242 0.858388 8.50804 0.858388C6.03714 0.858388 4.09654 1.42146 2.75711 1.98543C2.08745 2.26739 1.56834 2.54946 1.20871 2.76112C1.04668 2.85648 0.916981 2.93759 0.821661 2.9972C0.811289 3.00368 0.801323 3.00991 0.791768 3.01588C0.742392 3.04672 0.705966 3.06924 0.680196 3.08405C0.675947 3.0865 0.672282 3.08856 0.669149 3.09028H0.554799V3.2319V4.34784ZM7.97393 41.7702L8.07406 41.8704L8.1742 41.7702L11.0261 38.9184L11.1262 38.8182L11.0261 38.7181L8.1742 35.8662L8.07406 35.7661L7.97393 35.8662L5.12206 38.7181L5.02193 38.8182L5.12206 38.9184L7.97393 41.7702Z"
              fill="#990B31"
              stroke="#990B31"
              strokeWidth="0.283224"
            />
          </svg>

          <h2>{ data.questionnaire }<br/>
          { data.questionnaire2 }</h2>
      </Stack>
    )
}

export default Title;